__turbopack_context__.v({
  "walkthrough": "kalshi-whales-module__SlZksG__walkthrough",
});
